// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getGreeksDummyData = () => {
    return {
        PacketIdentifier: "G",
        MessageLength: 68,
        Token: 48315,
        IV: 0.125265732,
        DELTA: 0.675758064,
        THETA: -8.149248,
        VEGA: 8.463194,
        GAMMA: 0.00121955038,
        IV_VWAP: 0.126894742,
        VANNA: -1.551725,
        CHARM: 0.0149416318,
        SPEED: -0.00000195480061,
        ZOMMA: -0.007786678,
        COLOR: -0.00007497828,
        VOLGA: 1664.97009,
        VETA: 96.11483,
        TGR: -6682.17432,
        TV: -0.9629046,
        DTR: -0.08292275,
    };
};
function defaultGreeks() {
    return [
        { id: "DELTA" },
        { id: "THETA" },
        { id: "VEGA" },
        { id: "GAMMA" },
        { id: "IV" },
    ];
}
export { defaultGreeks };
